export default function (s) {
  var u = s.toUpperCase()
  if (u === s) s = s.toLowerCase()
  return s.replace(/^(.)|\s(.)/g, function ($1) { return $1.toUpperCase() })
}
